import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { History } from "lucide-react";

const LABELS = { account_id: "Caisse", type: "Type", montant: "Montant", motif: "Motif", categorie: "Catégorie", date: "Date" };
const fmt = (k, v, accName) => (k === "account_id" ? accName(v) : k === "type" ? (v === "entree" ? "Entrée" : "Sortie") : k === "montant" ? `${Number(v).toLocaleString("fr-FR")} FCFA` : v || "—");

export function TxHistory({ h, id, accName = (v) => v }) {
  const last = h[h.length - 1];
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="ml-2 inline-flex items-center gap-1 rounded bg-amber-50 px-1.5 py-0.5 text-[10px] font-medium text-amber-700" data-testid={`tx-history-${id}`}>
          <History className="h-3 w-3" />Modifiée
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80 text-xs space-y-3 max-h-80 overflow-y-auto">
        <p className="font-semibold text-sm">Historique des modifications</p>
        {[...h].reverse().map((e, i) => (
          <div key={i} className="border-l-2 border-amber-300 pl-2">
            <p className="text-slate-500">{new Date(e.at).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })} · {e.by}</p>
            {Object.keys(e.after).map((k) => <p key={k}><b>{LABELS[k] || k}</b> : <span className="line-through text-slate-400">{fmt(k, e.before[k], accName)}</span> → {fmt(k, e.after[k], accName)}</p>)}
          </div>
        ))}
        <p className="text-slate-400">Dernière modification par {last.by}</p>
      </PopoverContent>
    </Popover>
  );
}
